import styled from 'styled-components';

import {
  scale080,
  spaceL,
  spaceXL,
  xdlColorBorderSoft,
} from '@xing-com/tokens';

export const CtaContainer = styled.div`
  border-top: 1px solid ${xdlColorBorderSoft};
  display: flex;
  gap: ${scale080};

  margin-top: ${spaceXL};
  padding: ${spaceL} 0;
  justify-content: flex-end;
`;
